import { render } from "./CookiePopupComponent.vue?vue&type=template&id=58309dbf&scoped=true"
import script from "./CookiePopupComponent.vue?vue&type=script&lang=js"
export * from "./CookiePopupComponent.vue?vue&type=script&lang=js"

import "./CookiePopupComponent.vue?vue&type=style&index=0&id=58309dbf&scoped=true&lang=css"

import exportComponent from "C:\\Users\\epentilescu\\source\\repos\\Delicitate V2\\front-end\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58309dbf"]])

export default __exports__